import { Link } from '@chakra-ui/next-js';
import { Box, Flex } from '@chakra-ui/react';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import CrossIcon from '@app-ila/components/Icons/CrossIcon';
import HamburgerIcon from '@app-ila/components/Icons/HamburgerIcon';
import ILALogo from '@app-ila/components/Icons/ILALogo';
import ILAPrograms from '@app-ila/Section/ILAPrograms';
import { useMediaQuery } from 'react-responsive';
import NoPaperFormsScript from '@app-ila/components/Utility/NoPaperFormsScript';

export default function ILAHeader({ showPrograms, setShowPrograms }) {
  const isSmallScreen = useMediaQuery({ maxWidth: 768 });
  const pathName = usePathname();
  let pageflag = "other"
  if(pathName === '/sadhguru-academy/gen-a-entrepreneurship-bootcamp'){
    pageflag = "genA"
  }
  // useEffect(() => {
  //   if (showPrograms) {
  //     document.body.style.overflow = 'hidden';
  //   } else {
  //     document.body.style.overflow = 'auto';
  //   }
  // }, [showPrograms]);

  useEffect(
    () => () => {
      setShowPrograms(false);
    },
    [pathName]
  );

  return (
    <>
      <NoPaperFormsScript />
    <Box
      maxW={{
        base: '100%',
        sm: '540px',
        md: '720px',
        lg: '960px',
        xl: '1170px',
        '2xl': '1330px',
      }}
      mx="auto"
      width="100%"
      bgColor={{
        base: '#08084A',
        md: 'inherit',
      }}
      backgroundImage={{
        base: "url('https://static.sadhguru.org/d/46272/1692985330-artboard-ila.png')",
        md: 'inherit',
      }}
      backgroundRepeat="no-repeat"
      bgPos="top right"
      // position="fixed"
      // left="0"
      // top="0"
      overflow="auto"
    >
      <Flex
        justifyContent="space-between"
        alignItems="center"
        className="headerLogo"
        padding={{
          base: '20px 16px 30px 16px',
          sm: '20px 10px 30px 10px',
          xl: '40px 10px 30px 10px',
        }}
      >
        {/* <NextLink passHref legacyBehavior> */}
        <Link
          position={'relative'}
          top={{ base: '6px', md: '5px' }}
          href={"/sadhguru-academy"}
        >
          <ILALogo
            width={isSmallScreen ? 86 : 120}
            height={isSmallScreen ? 56 : 78}
            pflag={pageflag}
          />
        </Link>
        {/* </NextLink> */}
        {showPrograms ? (
          <CrossIcon
            width={isSmallScreen ? '32px' : '46px'}
            height={isSmallScreen ? '32px' : '46px'}
            onClick={() => setShowPrograms(false)}
            style={{ cursor: 'pointer' }}
          />
        ) : (
          <HamburgerIcon
            width={isSmallScreen ? '32px' : '46px'}
            height={isSmallScreen ? '32px' : '46px'}
            onClick={() => setShowPrograms(true)}
            style={{ cursor: 'pointer' }}
          />
        )}
      </Flex>
      {showPrograms ? (
        <ILAPrograms
          setShowPrograms={setShowPrograms}
          onClick={() => setShowPrograms(false)}
        />
      ) : null}
      <style>
        {`
          .css-1rytwe8 {
            width: 120px !important;
            height: 78px !important;
          }
          @media (max-width:730px){
            .css-1rytwe8{
              width: 86px !important;
              height:56px !important;
            }
          }
        `}
      </style>
    </Box>
    </>
  );
}
